import React from 'react';
import 'rc-banner-anim/assets/index.css';
import { Button, Col, Image, Row } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Content2 = (props) => {
  const { dataSource, ...restProps } = props;
  const { t, i18n } = useTranslation();
  const { titleWrapper, childWrapper, page, block } = dataSource;
  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content2" style={{ background: '#fff' }}>
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>
          <Row>
            <Col md={10} xs={24}>
              <div className={childWrapper.className}>
                {
                  childWrapper.children.children.children.map((item, i) => {
                    return (
                      <div className={item.className} key={i.toString()}>
                        <p>{t(item.title)}</p>
                        <div
                          dangerouslySetInnerHTML={{ __html: t(item.children) }}></div>
                      </div>
                    );
                  })
                }
              </div>
            </Col>
            <Col md={14} xs={24}>
              <Image src={require(`@/assets/production/tool/tool-02${i18n.language === 'en' ? '_en' : ''}.png`)} />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Content2;
